import { useState, useEffect } from 'react';
// import { reactPlugin } from '../../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import cn from 'clsx';
import { searchStyles } from './searchStyles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { useDispatch, useSelector } from 'react-redux';
import {
  getSearchResult,
  setSelectedSearch,
  getSelectedSearch,
  getJourneyNameType,
  setJourneyNameType,
  getSearchTPResult,
  setSearchTPResult,
  getRPComponents,
  getFileTraverseOrder,
} from '../../../store';
import { styled } from '@mui/material/styles';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CONSTANTS from '../../../constants/constants';

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
}));

interface SearchComponentProps {
  header: string;
  searchText: string;
  searchCategory: string[];
  close: any;
}

function SearchComponent({ header, searchText, searchCategory, close }: SearchComponentProps) {
  const data = useSelector(getSearchResult);
  const searchTPResult = useSelector(getSearchTPResult);
  const selectedSearch = useSelector(getSelectedSearch);
  const journeyNameType = useSelector(getJourneyNameType);
  const rpComponents = useSelector(getRPComponents);
  const fileTraverseOrder = useSelector(getFileTraverseOrder);
  const [legends, setLegends] = useState<string[]>([]);
  const [showData, setShowData] = useState<any[]>([]);
  const dispatch = useDispatch();
  const classes = searchStyles();

  useEffect(() => {
    let finalRes: any = [];
    let _legends: string[] = [];
    let _obj: any = { groupName: '', val: [] };
    data.forEach((el: any) => {
      if (el['type'] === journeyNameType['type'] && el['journeyId'] === journeyNameType['name']) {
        if (_obj['groupName'] != '') {
          // If the previous res orch step was a subjourney, add it to finalRes
          finalRes.push(_obj);
          _obj = { groupName: '', val: [] };
        }
        el['highlightPreCondition'] && !_legends.includes('precondition') && _legends.push('precondition');
        el['highlightStep'] && !_legends.includes('orchStep') && _legends.push('orchStep');
        finalRes.push(el);
      } else {
        const key = el['type'] + '---' + el['journeyId'];
        if (key !== _obj['groupName']) {
          if (_obj['groupName'] != '') {
            // This happens if two consecutive subjourney occurs
            finalRes.push(_obj);
          }
          // Inside a group for first time
          _obj = { groupName: key, val: [] };
        }
        _obj['val'].push(el);
      }
    });
    if (_obj['groupName'] != '') {
      // This happens if the last orch Step is a subJourney
      finalRes.push(_obj);
    }
    setLegends(_legends);
    setShowData(finalRes);
  }, [data, journeyNameType]);

  const displayClaimInfo = (id: string, type: string, claim: any) => {
    return (
      <div className={classes.flexCol} key={claim['claimTypeReferenceId']}>
        <div className={classes.flexRow}>
          {claim['claimTypeReferenceId'].toLowerCase().includes(searchText.toLowerCase()) ? (
            <b>{claim['claimTypeReferenceId']}</b>
          ) : (
            <span>{claim['claimTypeReferenceId']}</span>
          )}
          &nbsp;&nbsp;&nbsp;
          {!claim['expand'] && (
            <span
              className={classes.pointer}
              onClick={() => {
                dispatch(
                  setSearchTPResult({
                    ...searchTPResult,
                    [id]: {
                      ...searchTPResult[id],
                      [type]: {
                        ...searchTPResult[id][type],
                        [claim['claimTypeReferenceId']]: { ...claim, expand: true },
                      },
                    },
                  }),
                );
              }}
            >
              <VisibilityIcon />
            </span>
          )}
          {claim['expand'] && (
            <span
              className={classes.pointer}
              onClick={() => {
                dispatch(
                  setSearchTPResult({
                    ...searchTPResult,
                    [id]: {
                      ...searchTPResult[id],
                      [type]: {
                        ...searchTPResult[id][type],
                        [claim['claimTypeReferenceId']]: { ...claim, expand: false },
                      },
                    },
                  }),
                );
              }}
            >
              <VisibilityOffIcon />
            </span>
          )}
        </div>
        {claim['expand'] && (
          <div className={cn(classes.indent, classes.flexCol)}>
            {claim['partnerClaimType'] && (
              <div className={classes.flexRow}>
                Partner Claim Type :{' '}
                {searchCategory.includes(CONSTANTS.CATEGORY.PARTNERCLAIMTYPE) &&
                claim['partnerClaimType'].toLowerCase().includes(searchText.toLowerCase()) ? (
                  <b>{claim['partnerClaimType']}</b>
                ) : (
                  <span>{claim['partnerClaimType']}</span>
                )}
              </div>
            )}
            {claim['defaultValue'] && (
              <div className={classes.flexRow}>
                Default Value :{' '}
                {searchCategory.includes(CONSTANTS.CATEGORY.DEFAULTVALUE) &&
                claim['defaultValue'].toLowerCase().includes(searchText.toLowerCase()) ? (
                  <b>{claim['defaultValue']}</b>
                ) : (
                  <span>{claim['defaultValue']}</span>
                )}
              </div>
            )}
            {claim.hasOwnProperty('required') && (
              <div className={classes.flexRow}>Required : {claim['required'].toString()}</div>
            )}
            {claim.hasOwnProperty('alwaysUseDefaultValue') && (
              <div className={classes.flexRow}>
                Always Use Default Value : {claim['alwaysUseDefaultValue'].toString()}
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  const displayTPData = (id: string, tpData: any) => {
    if (!tpData) return;
    return (
      <>
        {['inputClaims', 'outputClaims', 'displayClaims', 'persistedClaims'].map(
          (type: string) =>
            tpData.hasOwnProperty(type) && (
              <div className={classes.flexCol} key={type}>
                <i>{type}:</i>
                {Object.keys(tpData[type]).map((claimName: string) =>
                  displayClaimInfo(id, type, tpData[type][claimName]),
                )}
              </div>
            ),
        )}
        {['inputClaimsTransformations', 'outputClaimsTransformations'].map(
          (type: string) =>
            tpData.hasOwnProperty(type) && (
              <div className={classes.flexCol} key={type}>
                <i>{type}:</i> <b>{tpData[type].join(', ')}</b>
              </div>
            ),
        )}
        <br />
        {['validationTechnicalProfiles'].map(
          (type: string) =>
            tpData.hasOwnProperty(type) && (
              <div className={classes.flexCol} key={type}>
                <i>{type}:</i>
                {tpData[type].map((tpName: string, index: number) => (
                  <div key={index}>
                    {tpName.toLowerCase().includes(searchText.toLowerCase()) ? <b>{tpName}</b> : <span>{tpName}</span>}
                    <div className={classes.indent} key={tpName}>
                      {displayTPData(tpName, searchTPResult[tpName])}
                    </div>
                  </div>
                ))}
              </div>
            ),
        )}
      </>
    );
  };

  const displayOrchStep = (orchStep: any, highlight: boolean) => (
    <div className={classes.mt1}>
      {orchStep.hasOwnProperty('precondition') && (
        <div className={cn(classes.flexCol)}>
          <i>Precondition</i>{' '}
          <b
            className={cn(highlight && classes.pointer)}
            onClick={() => {
              if (
                selectedSearch &&
                selectedSearch.hasOwnProperty('precondition') &&
                selectedSearch?.preconditionId === orchStep?.preconditionId &&
                selectedSearch?.journeyId === orchStep?.journeyId &&
                selectedSearch?.type === orchStep?.type &&
                journeyNameType['name'] === selectedSearch?.journeyId &&
                journeyNameType['type'] === selectedSearch?.type
              ) {
                dispatch(setSelectedSearch({}));
                close({});
              } else {
                dispatch(setSelectedSearch(orchStep));
                close(orchStep);
              }
            }}
          >
            {orchStep['precondition']}
          </b>
        </div>
      )}
      {orchStep.hasOwnProperty('orchStepName') && (
        <div className={classes.flexCol}>
          <i>Name</i>{' '}
          <div
            className={cn(highlight && classes.pointer)}
            onClick={() => {
              if (
                selectedSearch &&
                selectedSearch.hasOwnProperty('orchStepName') &&
                selectedSearch?.orchStepName === orchStep?.orchStepName &&
                selectedSearch?.journeyId === orchStep?.journeyId &&
                selectedSearch?.type === orchStep?.type &&
                journeyNameType['name'] === selectedSearch?.journeyId &&
                journeyNameType['type'] === selectedSearch?.type
              ) {
                dispatch(setSelectedSearch({}));
                close({});
              } else {
                dispatch(setSelectedSearch(orchStep));
                close(orchStep);
              }
            }}
          >
            {searchCategory.includes(CONSTANTS.CATEGORY.ORCHSTEPNAME) &&
            orchStep['orchStepName'].toLowerCase().includes(searchText.toLowerCase()) ? (
              <b>{orchStep['orchStepName']}</b>
            ) : (
              <span>{orchStep['orchStepName']}</span>
            )}
          </div>
          <div className={classes.indent}>
            {displayTPData(orchStep['orchStepName'], searchTPResult[orchStep['orchStepName']])}
          </div>
        </div>
      )}
    </div>
  );

  const handleExpand = (
    resCategory: 'Group' | 'CurrentJ',
    journeyType: 'UserJourneys' | 'SubJourneys',
    id: string,
    index: number,
  ) => {
    if (resCategory === 'Group') {
      let _temp = [...showData];
      _temp.forEach((el: any, ind: number) => {
        if (
          el.hasOwnProperty('groupName') &&
          journeyType === el['groupName'].split('---')[0] &&
          id === el['groupName'].split('---')[1]
        ) {
          _temp[ind]['expanded'] = el.hasOwnProperty('expanded') ? !el['expanded'] : true;
        }
      });
      setShowData(_temp);
    } else {
      // resCategory === 'CurrentJ'
    }
  };

  return (
    <>
      <Box className={classes.boxStyle}>
        <div className={cn(classes.header)}>
          <div className={classes.headerLeft}>
            <div className={cn(classes.flexRow, classes.searchTitle)}>{header}</div>
            {showData.length > 0 && <div className={classes.flexRow}>Fetched {showData.length} rows.</div>}
          </div>
          <div className={classes.headerRight}>
            <ClearOutlinedIcon onClick={() => close(null)} className={classes.delete} />
          </div>
        </div>
        <div className={cn(classes.legendBar)}>
          {legends.length > 0 && (
            <div className={classes.flexRow}>
              {legends.includes('precondition') && (
                <div className={classes.legend}>
                  <div className={cn(classes.legendColor, classes.preconditionLegend)}></div>
                  <div>Precondition</div>
                </div>
              )}
              {legends.includes('orchStep') && (
                <div className={classes.legend}>
                  <div className={cn(classes.legendColor, classes.orchStepLegend)}></div>
                  <div>Orch Step</div>
                </div>
              )}
              <div className={classes.legend}>
                <div className={cn(classes.legendColor, classes.selectedLegend)}></div>
                <div>Selected</div>
              </div>
            </div>
          )}
        </div>
        <div className={cn(classes.flexCol, classes.searchBody)}>
          {showData.length === 0 && <div className={classes.noResult}>No search results found.</div>}
          {showData.length > 0 &&
            showData.map((el: any, index: number) => {
              return (
                <div
                  key={index}
                  className={cn(
                    classes.entry,
                    journeyNameType['type'] === el['type'] && journeyNameType['name'] === el['journeyId']
                      ? el['highlightStep']
                        ? classes.orchStepSearched
                        : classes.preconditionSearched
                      : classes.unselected,

                    selectedSearch &&
                      ((selectedSearch.hasOwnProperty('orchStepName') &&
                        selectedSearch?.orchStepName === el?.orchStepName) ||
                        (selectedSearch.hasOwnProperty('precondition') &&
                          selectedSearch?.preconditionId === el?.preconditionId)) &&
                      selectedSearch?.journeyId === el?.journeyId &&
                      selectedSearch?.type === el?.type &&
                      journeyNameType['name'] === selectedSearch?.journeyId &&
                      journeyNameType['type'] === selectedSearch?.type
                      ? classes.selected
                      : '',
                  )}
                >
                  {!el.hasOwnProperty('groupName') && (
                    <div className={cn(classes.orchStep)}>{displayOrchStep(el, true)}</div>
                  )}
                  {el.hasOwnProperty('groupName') && journeyNameType['type'] === 'UserJourneys' && (
                    <div className={cn(classes.orchStep, classes.flexCol)}>
                      <div className={classes.flexRow}>
                        <div
                          className={cn(classes.flexExpand, classes.pointer, classes.flexCol)}
                          onClick={() => {
                            dispatch(
                              setJourneyNameType({ name: el['val'][0]['journeyId'], type: el['val'][0]['type'] }),
                            );
                          }}
                        >
                          <span className={classes.mb1}>
                            {searchCategory.includes(CONSTANTS.CATEGORY.ORCHSTEPNAME) &&
                            el['groupName'].split('---')[1].toLowerCase().includes(searchText.toLowerCase()) ? (
                              <b>{el['groupName'].split('---')[1]} </b>
                            ) : (
                              <span>{el['groupName'].split('---')[1]} </span>
                            )}
                            ( {el['groupName'].split('---')[0] === 'SubJourneys' ? 'SubJourney' : 'UserJourney'})
                          </span>
                        </div>

                        <ExpandMore
                          expand={el['expanded']}
                          onClick={() => {
                            handleExpand(
                              'Group',
                              el['groupName'].split('---')[0] === 'SubJourneys' ? 'SubJourneys' : 'UserJourneys',
                              el['groupName'].split('---')[1],
                              index,
                            );
                          }}
                          aria-expanded={el['expanded']}
                          aria-label="show more"
                        >
                          <ExpandMoreIcon />
                        </ExpandMore>
                      </div>
                      {el['expanded'] && (
                        <div className={classes.flexCol}>
                          {el['val'].map((orchStep: any, index: number) => (
                            <div key={index}>{displayOrchStep(orchStep, false)}</div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}

          {journeyNameType['type'] === 'SubJourneys' && (
            <Button
              className={cn(classes.mt1, classes.mb1)}
              onClick={() => {
                dispatch(
                  setJourneyNameType({
                    // @ts-ignore
                    name: rpComponents[fileTraverseOrder[fileTraverseOrder.length - 1]]['defaultUserJourney'],
                    type: 'UserJourneys',
                  }),
                );
              }}
              variant="contained"
              color="primary"
            >
              Go back to parent User Journey
            </Button>
          )}
        </div>
      </Box>
    </>
  );
}

// export default withAITracking(reactPlugin, SearchComponent);
export default SearchComponent;
